import Button from "../../../atoms/button";
import Input from "../../../atoms/input";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useFormik } from "formik";
import { validationSchema } from "./schema";
import { registerWithEmailAndPassword } from "../../../../firebase/firebaseutils";
import React, { useState } from "react";
import Loader from "../../../atoms/loader";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import { useContext } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

const SignupForm = ({ setcurrentTab }) => {
  const classes = useStyles();
  let sm = useMediaQuery("(max-width:600px)");
  const [error, setError] = useState("");
  const res = useContext(AppContext);
  let navigate = useNavigate();

  const setLoading = res?.appLoadingStates?.setappLoader;
  const loading = res?.appLoadingStates?.appLoader;

  const setUser = res?.appLoadingStates?.setUser;

  const handleClick = () => {
    setcurrentTab(0);
  };

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      contact: "",
      password: "",
      confirmPassword: "",
    },
    onSubmit: async (values) => {
      const { email, password, firstName, lastName, contact } = values;
      const status = "signed-up";
      setLoading(true);
      const response = await registerWithEmailAndPassword(
        email,
        password,
        firstName,
        lastName,
        contact,
        status,
      );

      setLoading(false);
      if (response.error) {
        setError("Something went wrong, or User already exists");
      } else {
        setUser(response);
        navigate(`/dashboard/${response.uid}`);
      }
    },
    validationSchema: validationSchema,
  });

  if (loading) return <Loader />;

  return (
    <div className={classes.root}>
      <div onClick={handleClick}>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 600,
            marginBottom: "10px",
            marginTop: "10px",
            color: "#610000",
          }}
        >
          Signup
        </Typography>
      </div>

      <form onSubmit={formik.handleSubmit} className={classes.form}>
        <div
          style={{ display: sm ? "flex" : "", flexFlow: sm ? "column" : "row" }}
        >
          <Input
            id="firstName"
            name="firstName"
            label="First Name"
            value={formik.values.firstName}
            onChange={formik.handleChange}
            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
            helperText={formik.touched.firstName && formik.errors.firstName}
            onBlur={formik.handleBlur}
            height="5rem"
            width="15rem"
            style={{ marginBottom: "5px" }}
          />
          <Input
            id="lastName"
            name="lastName"
            label="Last Name"
            value={formik.values.lastName}
            onChange={formik.handleChange}
            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
            helperText={formik.touched.lastName && formik.errors.lastName}
            onBlur={formik.handleBlur}
            height="5rem"
            width="15rem"
            style={{ marginLeft: sm ? "" : "20px" , marginBottom: "5px" }}
          />
        </div>
        <div  style={{ display: sm ? "flex" : "", flexFlow: sm ? "column" : "row" }}>
          <Input
            id="email"
            name="email"
            label="Email Address"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            onBlur={formik.handleBlur}
            height="5rem"
            width="15rem"
            style={{ marginBottom: "5px" }}
          />
          <Input
            id="contact"
            name="contact"
            label="Contact Number"
            value={formik.values.contact}
            onChange={formik.handleChange}
            error={formik.touched.contact && Boolean(formik.errors.contact)}
            helperText={formik.touched.contact && formik.errors.contact}
            onBlur={formik.handleBlur}
            height="5rem"
            width="15rem"
            style={{ marginLeft: sm ? "" : "20px" , marginBottom: "5px" }}
            type="number"
          />
        </div>
        <div style={{ display: sm ? "flex" : "", flexFlow: sm ? "column" : "row" }}>
          <Input
            id="password"
            name="password"
            label="Password"
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            onBlur={formik.handleBlur}
            height="5rem"
            width="15rem"
            type="password"
            style={{ marginBottom: "5px" }}
          />
          <Input
            id="confirmPassword"
            name="confirmPassword"
            label="Confirm Password"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            error={
              formik.touched.confirmPassword &&
              Boolean(formik.errors.confirmPassword)
            }
            helperText={
              formik.touched.confirmPassword && formik.errors.confirmPassword
            }
            onBlur={formik.handleBlur}
            height="5rem"
            width="15rem"
            type="password"
            style={{ marginLeft: sm ? "" : "20px" , marginBottom: "5px" }}
          />
        </div>
        <Typography
          sx={{
            fontSize: "14px",
            color: "#B41D08",
            visibility: error ? "visibile" : "hidden",
            marginBottom: "20px",
          }}
        >
          {error}
        </Typography>
        <Button
          type="submit"
          label="Signup"
          width="13rem"
          bgColor="#610000"
          style={!error ? { marginTop: "-20px" } : ""}
        />
      </form>
      <Typography
        variant="body1"
        sx={{ marginTop: "10px", color: "#525257", marginBottom: "10px" }}
      >
        Already have an account?
        <span
          onClick={handleClick}
          style={{ color: "#1769aa", marginLeft: "3px", cursor: "pointer" }}
        >
          Signin
        </span>
      </Typography>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexFlow: "column",
  },
  form: {
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  textStyles: {
    cursor: "pointer",
    fontSize: "16px",
  },
}));

export default SignupForm;
